import React, { Component } from 'react';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';

import language from '../../../assets/languages/language';
import AppRoutes from '../../config/AppRoutes';
import { renderHTMLContent } from '../../../common/function';
/* eslint-disable*/
class Viewques extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      questions: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 1000,
      answered: [],
      answered_state: [],
      showFreePremium: true,
      subscription_details: '',
      chapters: [],
      subscription_details_for_isActive: '',
      chapter_video_redirect: '',
      selectedmenu: 'cfa_3',
      isVideo: true,
      Loader: false,
    };
  }
  static contextTypes = {
    router: React.PropTypes.object,
  };

  _getReadings = () => {
    let path = AppRoutes.CFA3_NOTES_READINGS.replace(':chapter', this.props.params.chapter_no);
    this.context.router.push({
      pathname: path,
    });
  };

  _goToVideo = () => {
    this.setState(
      {
        chapter_video_redirect: this.state.chapters[parseInt(this.props.params.chapter_no) - 1],
      },
      () => {
        // TODO work

        let path = AppRoutes.CFA3_VIDEO_DISPLAY.replace(
          ':id',
          this.state.chapter_video_redirect.chapter_no,
        )
          .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
          .replace(':chapter_id', this.state.chapter_video_redirect.chapter_no)
          .replace(':index', 0);
        this.context.router.push({
          pathname: path,
          search: `?chapter_name=${this.state.chapter_video_redirect.chapter_name}/${this.state.chapter_video_redirect.chapter_no
            }`,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            chapter: this.state.chapter_video_redirect,
            showFreePremium: this.state.showFreePremium,
          },
        });
      },
    );
  };

  _beginNotes = (item, e) => {
    // console.log('beginNotes ---> ', item);
    let path = AppRoutes.CFA3_BEGIN_NOTES.replace(':notesid', item.chapter_id)
      .replace(':readingid', item.reading_id)
      .replace(':id', item.id);
    this.context.router.push({
      pathname: path,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        reading: item.reading_id,
        chapter: item.chapter_id,
      },
    });
  };

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    const getProfileInfo = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfo).then(
      async resp => {
        if (resp.profileInfo) {
          this.setState({
            isVideo: resp.profileInfo.isVideo,
          });
        }
      },
    );

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      reading_id: this.props.params.id,
      chapter_id: this.props.params.chapter_no,
      offset: this.state.offset,
      limit: this.state.limit,
    };
    // console.log(data);
    await FD.callAPI(App_data.backend_api + '/cfa3_notes/getNotes', data).then(resp => {
      // console.log(resp);
      if (resp.success) {
        this.setState({ ValidToken: true, questions: resp.questions });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.exam_package === '' &&
          resp.profileInfo.exam_package
        ) {
          this.setState({
            showFreePremium: true,
            Loader: true,
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3VideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false, Loader: true });
                } else {
                  this.setState({
                    showFreePremium: true,
                    Loader: true,
                  });
                }
              } else {
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage == '' &&
          resp.profileInfo.cfaUnlimitedActiveExam == ''
        ) {
          // console.log('if working')
          this.setState({
            showFreePremium: true,
            Loader: true,
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;

                isInArray_var = Cfa3SubscriptionCheck.checkCfa3VideosSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                //   console.log(isInArray_var);
                if (isInArray_var) {
                  // console.log('IF WORKING')
                  this.setState({ showFreePremium: false, Loader: true });
                } else {
                  // console.log('ELSE WORKING')
                  this.setState({ showFreePremium: true, Loader: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  }

  render() {
    let questions = this.state.questions;
    // console.log("this.state.questions;", this.state.questions);
    let { chapters } = this.state;
    let { chapter_no } = this.props.params;
    // let countVideo = chapters[chapter_no - 1]
    //   ? chapters[this.props.params.chapter_no - 1].Countvideos
    //   : null;
    let data = '';
    if (this.state.questions.length && this.state.Loader) {
      data = questions.map((item, index) => (
        <div className='col-md-6 col-lg-4' key={index}>
          <div onClick={this._beginNotes.bind(this, item)} className='border_box'>
            <div className='border_box_title'>
              <p>
                <img
                  src={App_data.frontend_url + '/img/notes/notes_icon4.svg'}
                  className='margin_right_10'
                  alt=''
                  width='21'
                />
                {/* the title is the admin "Name" field as-is — no auto "LOS N" prefix */}
                {item.name.length < 90 ? item.name : item.name.substr(0, 100) + '...'}{' '}
                ({language.LC().N} {item.id})
              </p>
            </div>
            <div className='padding_box'>
              {/* <p>{this.state.answered_state[index]}</p> */}

              {item.description ? (
               renderHTMLContent(
                item.description.substring(
                  0,
                  item.description.indexOf('$$') !== -1 ? item.description.indexOf('$$') : 130,
                ) + '...',
                "div",
                "view_question_height view_questionhtml margin_bottom_40 cfa_notes_view",
                { contentEditable: "false" }
              )              
              ) : null}

              <UserInfo
                itemid={item.id}
                chapter_id={this.props.params.chapter_no}
                reading_id={this.props.params.id}
                idname={this.state.idname}
                token={this.state.token}
                answered_state={index}
              />
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.props.params.reading}</h1>
          </div>

          <div
            className={
              this.state.isVideo === true
                ? `col-md-4 text-md-right margin_bottom_20`
                : `col-md-4 text-md-right margin_bottom_20`
            }
          >
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {' '}
              {language.LC().CHANGE_READING}{' '}
            </button>
          </div>

          {/* {this.state.isVideo === true ? (
            <div className='col-md-2 text-md-right margin_bottom_20'>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._goToVideo}
                disabled={!countVideo}
              >
                {language.LC().GO_TO_VIDEOS}
              </button>
            </div>
          ) : null} */}
        </div>
        <div className='row'>{data}</div>
      </div>
    );
  }
}
function UserInfo(props) {
  var data = {
    itemid: props.itemid,
    chapter_id: props.chapter_id,
    reading_id: props.reading_id,
    idname: props.idname,
    token: props.token,
  };

  FD.callAPI(App_data.backend_api + '/cfa3_notes/getNotesByuser', data).then(resp => {
    if (resp.success) {
      if (resp.success == 'success') {
        if (document.getElementById('user_question_status' + props.answered_state) != null) {
          document.getElementById('user_question_status' + props.answered_state).innerHTML = 'Read';

          document.getElementById('user_question_status' + props.answered_state).id =
            'answered_status';
        }
      } else {
        if (document.getElementById('user_question_status' + props.answered_state) !== null)
          document.getElementById('user_question_status' + props.answered_state).innerHTML =
            'Unread';

        if (document.getElementById('user_question_status' + props.answered_state) !== null)
          document.getElementById('user_question_status' + props.answered_state).id =
            'notanswered_status';
      }
    } else {
      document.getElementById('user_question_status' + props.answered_state).innerHTML =
        resp.success;
    }
  });

  return (
    <div>
      <div id={'user_question_status' + props.answered_state} />
    </div>
  );
}
export default Viewques;



// WEBPACK FOOTER //
// ./src/views/CFA3/Notes/NotesViewques.js